<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/gHbn8o/tc-custom/9781635339079.jpg?1719927355369" alt="This image is the cover for the book You Never Know"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">You Never Know
      </h1>
      <p class="bookDescription body article font2">
        <p>Hagen Wylie has it all figured out. He’s going to live in his hometown, be everybody’s friend, explore new relationships, and rebuild his life after the horrors of war. No muss, no fuss is the plan. He’s well on his way—until he finds out his first love has come home too. Hagen says it’s no big deal, but a chance encounter with Mitch Thayer’s two cute sons puts him directly in the path of the only guy he’s never gotten out of his head.</p><p>Mitch returned for three reasons: to raise his sons where he grew up, to move his furniture business and encourage it to thrive, and to win Hagen back. Years away made it perfectly clear the young man he loved in high school is the only one for him. The problem? He left town and they have not talked since.</p><p>If Hagen’s going to trust him again, Mitch needs to show him how he’s grown up and isn’t going to let go. They could have a new chance at love… but Hagen is insistent he’s not reviving a relationship with Mitch. Then again, you never know.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mary Calmes
      </h2>
      
      <p class="authorDescription body article">Mary Calmes believes in romance, happily ever afters, and the faith it takes for her characters to get there. She bleeds coffee, thinks chocolate should be its own food group, and currently lives in Kentucky with a five-pound furry ninja that protects her from baby birds, spiders, and the neighbor&rsquo;s dogs. To stay up to date on her ponderings and pandemonium (as well as the adventures of the ninja), follow her on Twitter @MaryCalmes, connect with her on Facebook, and subscribe to her Mary&rsquo;s Mob newsletter.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Dreamspinner Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6e612534